import { render, staticRenderFns } from "./stepInfo.vue?vue&type=template&id=f5810c6e&scoped=true&"
import script from "./stepInfo.vue?vue&type=script&lang=js&"
export * from "./stepInfo.vue?vue&type=script&lang=js&"
import style0 from "./stepInfo.vue?vue&type=style&index=0&id=f5810c6e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5810c6e",
  null
  
)

export default component.exports